enum HeaderEvents {
  UpperlineClick = 'upperline_tap',
  CountryChoice = 'upperline_country_choice',
}

export default HeaderEvents
